import { createSlice } from "@reduxjs/toolkit";
import { fetchWarehouseAllocation } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const WarehouseAllocationSlice = createSlice({
  name: "WarehouseAllocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseAllocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseAllocation.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchWarehouseAllocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Warehouse Packing List";
      });

  },
});

export default WarehouseAllocationSlice.reducer;
